var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import { Icon } from '@patternfly/react-core/dist/dynamic/components/Icon';
import { TextInput } from '@patternfly/react-core/dist/dynamic/components/TextInput';
import SearchIcon from '@patternfly/react-icons/dist/dynamic/icons/search-icon';
import '../ConditionalFilter/conditional-filter.css';
import classNames from 'classnames';
export function isFilterValue(item) {
    return item !== null && typeof item === 'object';
}
var TextFilter = function (_a) {
    var _b = _a.customIcon, customIcon = _b === void 0 ? _jsx(SearchIcon, {}) : _b, _c = _a.isDisabled, isDisabled = _c === void 0 ? false : _c, className = _a.className, innerRef = _a.innerRef, props = __rest(_a, ["customIcon", "isDisabled", "className", "innerRef"]);
    return (_jsx(Fragment, { children: _jsx(TextInput, __assign({}, props, { customIcon: _jsx(Icon, { className: "ins-c-search-icon", size: "md", children: customIcon }), isDisabled: isDisabled, "aria-label": props['aria-label'] || 'text input', className: classNames('ins-c-conditional-filter', className), "data-ouia-component-type": "PF5/TextInput", onKeyDown: function (e) { var _a; return e.key === 'Enter' && ((_a = props === null || props === void 0 ? void 0 : props.onSubmit) === null || _a === void 0 ? void 0 : _a.call(props, e)); }, ouiaId: "ConditionalFilter", "widget-type": "InsightsInput", ref: innerRef })) }));
};
export default TextFilter;
//# sourceMappingURL=TextFilter.js.map